var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-linear-wizard"},[_c('McWizard',{attrs:{"compact":"","withNumber":_vm.withNumber,"activeKey":_vm.activeKey,"items":_vm.items,"isSingleStatus":_vm.isSingleStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }